export const METAL_BAND_COLOR = "#aaaaaa"
export const METAL_BAND_THRESHOLD = 100
export const MAX_SCOPE_WORKFLOW_SECTIONS = 4
export const CAMERA_OPTICAL_DIAMETER = 36
export const PATCH_SCAN_POSITION_INCREMENT = 36

export const MIN_TEMP = -270
export const MAX_TEMP = 1000
export const MIN_PIPE_LENGTH = 100
export const MAX_PIPE_LENGTH = 10000
export const MIN_PIPE_DIAMETER = 25
export const MAX_PIPE_DIAMETER = 10000
export const MAX_PIPE_DIAMETER_FOR_DEFAULT_ANGLES = 483
export const MAX_SECTION_ANGLES = 40
export const MIN_THICKNESS = 0
export const MAX_THICKNESS = 1000
export const MAX_SECTION_LENGTH = 2000
export const MIN_SECTION_LENGTH = 100
export const MIN_PATCH_SECTION_SIZE = 100
export const MAX_PATCH_SECTION_SIZE = 2000

export const MAX_QR_CODE_CHARS = 2225
export const MAX_WORKFLOWS_TO_LOAD = 50

export const MAX_COMMENT_CHARACTERS = 2000
export const MAX_WORKFLOW_OVERVIEW_COMMENT_CHARACTERS = 4000

export const ANGULAR_THZ_HEATMAP_SIZES = [20, 24, 28, 32, 36]
export const PATCH_THZ_HEATMAP_SIZES = [4, 6, 7, 8, 10]

export const ANGULAR_IR_HEATMAP_SIZES = ANGULAR_THZ_HEATMAP_SIZES.map( x => x + 2)
export const PATCH_IR_HEATMAP_SIZES = PATCH_THZ_HEATMAP_SIZES.map( x => x * 2)

export const ANGULAR_METAL_HEATMAP_SIZES = ANGULAR_THZ_HEATMAP_SIZES.map (x => x + 4)
export const PATCH_METAL_HEATMAP_SIZES = PATCH_THZ_HEATMAP_SIZES.map( x => x * 4)

export const ASSET_TYPES = [
  {
    id: 0,
    name: "PIPE"
  },
  {
    id: 1,
    name: "VESSEL"
  }
]